module.exports = __webpack_public_path__ + "static/media/homelogo_inv.f8e962d2.svg";